// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar-footer {
  background-color: white;
  padding-right: 0px;
  padding-left: 0px;
}
.sidebar-footer p {
  background-color: #f9f9f9;
  padding-top: 8px;
  padding-left: 45px;
  height: 40px;
}
.sidebar-footer p a {
  width: 44px;
  height: 15px;
  left: 54px;
  top: 15px;
  font-family: "Montserrat", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 15px;
  letter-spacing: 0.05em;
  color: #121b2b;
}`, "",{"version":3,"sources":["webpack://./src/app/containers/components/app-sidebar-footer/app-sidebar-footer.component.scss"],"names":[],"mappings":"AAAA;EACE,uBAAA;EACA,kBAAA;EACA,iBAAA;AACF;AACE;EACE,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;AACJ;AACI;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,qCAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;AACN","sourcesContent":[".sidebar-footer {\n  background-color: white;\n  padding-right: 0px;\n  padding-left: 0px;\n\n  p {\n    background-color: #f9f9f9;\n    padding-top: 8px;\n    padding-left: 45px;\n    height: 40px;\n\n    a {\n      width: 44px;\n      height: 15px;\n      left: 54px;\n      top: 15px;\n      font-family: \"Montserrat\", sans-serif;\n      font-style: normal;\n      font-weight: normal;\n      font-size: 14px;\n      line-height: 15px;\n      letter-spacing: 0.05em;\n      color: #121b2b;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
